<!-- src/ui/components/bot/BotPicker.vue -->
<template>
  <b-card>
    <div class="d-flex align-items-center mb-2">
      <div class="font-weight-600">
        Selecione um bot
      </div>
      <b-spinner
        v-if="loading"
        small
        class="ml-2"
      />
      <div class="ml-auto">
        <b-button
          size="sm"
          variant="outline-secondary"
          @click="load"
        >
          Atualizar
        </b-button>
      </div>
    </div>

    <b-alert
      v-if="!loading && !bots.length"
      show
      variant="light"
    >
      Nenhum bot encontrado para esta conta.
    </b-alert>

    <b-list-group v-else>
      <b-list-group-item
        v-for="b in bots"
        :key="b.id"
        class="d-flex justify-content-between align-items-center"
      >
        <div>
          <div class="font-weight-600">
            {{ b.nome || ('Bot #' + b.id) }}
          </div>
          <div class="small text-muted">
            ID: {{ b.id }} • UUID: {{ b.uuid || '-' }}
          </div>
        </div>
        <div class="text-nowrap">
          <b-button
            size="sm"
            variant="primary"
            @click="openEditor(b.id, b.uuid)"
          >
            Abrir editor
          </b-button>

        </div>
      </b-list-group-item>
    </b-list-group>
  </b-card>
</template>

<script>

import { FlowsAPI } from '../../../functions/bot/api'

export default {
  name: 'BotPicker',
  props: {
    accountId: { type: [String, Number], required: true },
  },
  data: () => ({
    loading: false,
    bots: [],
  }),
  created() { this.load() },
  methods: {
    async load() {
      this.loading = true
      try {
        const resp = await FlowsAPI.listBotsByAccount(this.accountId)
        const data = resp && resp.data && resp.data.data ? resp.data.data : []
        this.bots = Array.isArray(data) ? data : []
      } catch (e) {
        this.$bvToast && this.$bvToast.toast('Não foi possível carregar os bots', { variant: 'danger' })
      } finally {
        this.loading = false
      }
    },
    // ✅ Envie o UUID junto
    openEditor(botId, botUuid) {
      this.$router.push({
        name: 'bot-oficial-flow-edit',
        params: { botId: String(botId) },
        query: { botUuid: botUuid || '' },
      })
    },
  },
}
</script>
